import { connect } from "react-redux";
import AddCorporateClient from "./addCorporateClient";
import { bindActionCreators } from "redux";
import {postCorpClient,getCorpClientList} from "services/redux/brandActivtion/corporateClient/action";

const mapStateToProps = (state) => ({
//   siteListData: state.baSiteListingReducer.siteListData,
//   siteFilters: state.baSiteListingReducer.siteFiltersData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postCorpClient,
      getCorpClientList
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddCorporateClient);
